import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useRegisterUserMutation({
	onError,
	onSuccess,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: Api.IUser) => void;
}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({
			accountId,
			user,
			sendWelcomeEmail = false,
		}: {
			accountId: string;
			user: Partial<Api.IUser>;
			sendWelcomeEmail?: boolean;
		}) => {
			return userSession.webServiceHelper.callAsync<Api.IUser>(
				`user/register?sendWelcomeEmail=${sendWelcomeEmail}`,
				'POST',
				{
					...user,
					accountId,

					email: user.primaryEmail.value,
				}
			);
		},
		onError: (error: Api.IOperationResultNoValue) => {
			onError?.(error);
			toast.error(error.systemMessage || 'Registration failed');
		},
		onSuccess,
	});
}
